<template>
    <div class="clearfix main_center" v-loading.fullscreen.lock="loading">
        <div class="right-content">
            <el-form ref="form" :model="form" label-width="180px">
                <el-card class="box-card">
                    <div slot="header" class="clearfix">
                        <span>项目信息</span>
                    </div>
                    <div class="form-content default-content">
                        <el-row>
                            <el-col :span="12">
                                <el-form-item label="项目名称：" size="small">
                                    {{ form.projectName }}
                                </el-form-item>
                            </el-col>
                        </el-row>
                        <el-row>
                            <el-col :span="12">
                                <el-form-item label="招标（采购）人：" size="small">
                                    {{ form.tendererName }}
                                </el-form-item>
                            </el-col>
                        </el-row>
                        <el-row>
                            <el-col :span="24">
                                <el-form-item label="招标（采购）项目内容：" size="small">
                                    {{ form.tenderContent }}
                                </el-form-item>
                            </el-col>
                        </el-row>
                    </div>
                </el-card>
                <el-card class="box-card" v-if="form.history">
                    <div slot="header" class="clearfix">
                        <span>原预约信息</span>
                    </div>
                    <div class="form-content default-content">
                        <el-row>
                            <el-col :span="12">
                                <el-form-item label="开标场地：" size="small">
                                    {{ form.history?.openVenue }}
                                </el-form-item>
                            </el-col>
                        </el-row>
                        <el-row>
                            <el-col :span="12">
                                <el-form-item label="使用开始时间：" size="small">
                                    {{ form.history?.openStartTime }}
                                </el-form-item>
                            </el-col>
                            <el-col :span="12">
                                <el-form-item label="使用结束时间：" size="small">
                                    {{ form.history?.openEndTime }}
                                </el-form-item>
                            </el-col>
                        </el-row>
                        <el-row>
                            <el-col :span="12">
                                <el-form-item label="评标场地：">
                                    <div class="placesChose" style="display: flex">
                                        {{ form.history?.evalVenue }}
                                    </div>
                                </el-form-item>
                            </el-col>
                        </el-row>
                        <el-row>
                            <el-col :span="12">
                                <el-form-item label="使用开始时间：">
                                    {{ form.history?.evalStartTime }}
                                </el-form-item>
                            </el-col>
                            <el-col :span="12">
                                <el-form-item label="使用结束时间：">
                                    {{ form.history?.evalEndTime }}
                                </el-form-item>
                            </el-col>
                        </el-row>
                        <el-row>
                            <el-col :span="24">
                                <el-form-item label="备注：" size="small">
                                    {{ form.history?.remarks }}
                                </el-form-item>
                            </el-col>
                        </el-row>
                    </div>
                </el-card>
                <el-card class="box-card">
                    <div slot="header" class="clearfix">
                        <span>场地预约信息</span>
                    </div>
                    <div class="form-content default-content">
                        <el-row>
                            <el-col :span="12">
                                <el-form-item label="开标场地：" size="small">
                                    {{ form.openVenue }}
                                </el-form-item>
                            </el-col>
                            <el-col :span="12" v-if="form.history">
                                <el-form-item label="变更次数：" size="small" >
                                    {{ form.changeCount || 0 }}
                                </el-form-item>
                            </el-col>
                        </el-row>
                        <el-row>
                            <el-col :span="12">
                                <el-form-item label="使用开始时间：" size="small">
                                    {{ form.openStartTime }}
                                </el-form-item>
                            </el-col>
                            <el-col :span="12">
                                <el-form-item label="使用结束时间：" size="small" prop="openEndTime">
                                    {{ form.openEndTime }}
                                </el-form-item>
                            </el-col>
                        </el-row>
                        <el-row>
                            <el-col :span="12">
                                <el-form-item label="评标场地：">
                                    <div class="placesChose" style="display: flex">
                                        {{ form.evalVenue }}
                                    </div>
                                </el-form-item>
                            </el-col>
                        </el-row>
                        <el-row>
                            <el-col :span="12">
                                <el-form-item label="使用开始时间：">
                                    {{ form.evalStartTime }}
                                </el-form-item>
                            </el-col>
                            <el-col :span="12">
                                <el-form-item label="使用结束时间：">
                                    {{ form.evalEndTime }}
                                </el-form-item>
                            </el-col>
                        </el-row>
                        <el-row>
                            <el-col :span="24">
                                <el-form-item label="备注：" size="small">
                                    {{ form.remarks }}
                                </el-form-item>
                            </el-col>
                        </el-row>
                    </div>
                </el-card>
            </el-form>
        </div>
        <div class="left-content">
            <div class="left-navbar">
                <el-button v-if="filingCBtn"
                           type="primary"
                           size="small"
                           @click="showAuditWindow(true, '同意')"
                >同意</el-button>
                <el-button v-if="backCBtn"
                           type="primary"
                           plain
                           size="small"
                           @click="showAuditWindow(false, '')"
                >退回</el-button>
                <el-button v-if="form.status === 2"
                           type="primary"
                           size="small"
                           @click="onClickChange"
                >变更</el-button>
                <el-button size="small" @click="backBtn">返回</el-button>
            </div>
        </div>
        <el-dialog title="意见栏" :visible.sync="dialogVisible" width="40%" append-to-body>
            <div class="dialogBox">
                <el-form ref="auditForm" :model="auditForm" label-width="90px" class="form">
                    <el-form-item label="意见：" style="width:90%;">
                        <el-input type="textarea" :rows="10" v-model="auditForm.suggest"></el-input>
                    </el-form-item>
                </el-form>
            </div>
            <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false" class="backBtn">返回</el-button>
        <el-button type="primary" @click="onClickApprove" style="margin-bottom:20px;">确 定</el-button>
      </span>
        </el-dialog>
    </div>
</template>

<script>
import {tabsCloseCurrentHandle} from '@/utils/routeTab';

export default {
    data() {
        return {
            form: {},
            filingCBtn: false, //同意按钮
            backCBtn: false, //退回按钮
            dialogVisible: false, //展示意见弹窗
            auditForm: { //展示意见弹窗表单
                isPass: null,
                suggest: ''
            },
            loading: false,
        }
    },
    filters: {
        undertakeDeptFilter(status) {
            //1 工程建设部 2 政府采购部 3 资源与产权交易部
            switch (status) {
                case 1:
                    return '工程建设部';
                case 2:
                    return '政府采购部';
                case 3:
                    return '资源与产权交易部';
                default:
                    return '';
            }
        },
    },
    activated() {
        this.id = this.$route.query.id;
        this.requestDetailData();
    },
    methods: {
        //获取详情数据
        requestDetailData() {
            this.$http.get(`/suit/get?venueId=${this.id}`).then(({data}) => {
                if (data.code === '1') {
                    this.form = {...data.data}
                    this.getFlow()
                }
            })
        },
        //获取流程
        getFlow() {
            this.$http.get(`/workflow/getInfo?processInstanceid=${this.form.processinstanceid}`).then(res => {
                if (res.data.data.taskId !== '') {
                    this.taskId = res.data.data.taskId;
                    res.data.data.buttons.forEach(item => {
                        if (item.type === 1) {
                            this.processSubmit = true;
                        }
                        if (item.type === 2) {
                            this.filingCBtn = true
                        }
                        if (item.type === 3) {
                            this.backCBtn = true
                        }
                        if (item.type === 10) {
                            this.backCBtn = true
                            this.filingCBtn = true
                        }
                    })

                }


            }).catch(e => {

            })
        },
        //展示意见
        showAuditWindow(isPass, msg) {
            this.dialogVisible = true;
            this.auditForm.suggest = msg;
            this.auditForm.isPass = isPass;
        },
        //返回
        backBtn() {
            tabsCloseCurrentHandle();
            this.$router.push({
                name: 'singleWindowServiceSiteList'
            })
            this.$refs.form.resetFields();
        },
        //审批
        onClickApprove() {
            if(!this.auditForm.suggest) {
                this.$message.error('请输入审批意见')
                this.$nextTick(() => { //为了解决被dialog遮挡的问题
                    const messages = document.querySelectorAll('.el-message');
                    messages.forEach(message => {
                        message.style.zIndex = 9999;
                    });
                });
                return
            }
            const params = {
                id: this.id,
                taskId: this.taskId,
                processinstanceid: this.form.processinstanceid,
                variables: {
                    commit: this.auditForm.isPass,
                    opinion: this.auditForm.suggest //见证意见
                },
            }
            this.loading = true;
            this.$http.post('/suit/approve', params).then(({data}) => {
                this.loading = false;
                this.dialogVisible = false;
                if (data.code === '1') {
                    this.$message.success('操作成功')
                    setTimeout(() => {
                        this.backBtn()
                    }, 500)
                } else {
                    this.$message.error(data.msg)
                }
            })
        },
        //变更
        onClickChange() {
            this.$router.replace({
                name: "singleWindowServiceSiteChange",
                query: {
                    id: this.id,
                }
            });
        },
    }


}
</script>

<style lang="less" scoped>
.angle_tag {
    margin-right: 10px !important;
}
</style>
